/* The optional parts of the panel.
 *
 * A workspace picks these while it is being created and can change its mind
 * later from فضای کاری › ماژول‌ها. The choice is a panel-side preference, not a
 * plan or a permission: the API keeps serving every one of these endpoints, and
 * turning a module off only takes its sidebar entry and its routes out of the
 * way. That is the point — a team that never sees a customer does not want a
 * «مشتریان» sitting in their sidebar forever, but nothing about their data
 * changes when they hide it.
 *
 * Permissions still apply on top: a module being on is what makes an entry
 * possible, not what makes it visible to someone who could never open it.
 *
 * `defaultOn` is what an organization that has never answered the question
 * gets. Everything that shipped before this screen existed is on, so no
 * existing workspace loses a section it was already using — see
 * `enabledModules` in utils/modules.js. */
export const MODULES = [
  {
    key: "customers",
    label: "مشتریان و CRM",
    description:
      "دفترچه‌ی مشتری‌ها، وصل‌کردنشون به پروژه‌ها و تسک‌ها، یادداشت و فایل روی هر مشتری.",
    defaultOn: true,
  },
  {
    key: "chat",
    label: "چت سازمانی",
    description: "گفتگوی مستقیم و گروهی بین اعضای سازمان، جدا از کامنت تسک‌ها.",
    defaultOn: true,
  },
  {
    /* Keep the technical key aligned with the API/model terminology. The UI
     * calls time entries «فعالیت»; system activity_log entries are displayed
     * as «تاریخچه» everywhere else. */
    key: "time_tracking",
    label: "ثبت فعالیت",
    description:
      "تایمر و ثبت دستی زمان روی تسک‌ها، فعالیت‌های من و گزارش زمان‌صرف‌شده‌ی سازمان.",
    defaultOn: true,
  },
  {
    key: "letters",
    label: "نامه‌نگاری",
    description:
      "کارتابل مکاتبات، شماره‌گذاری رسمی، گردش امضا، دبیرخانه، بایگانی و خروجی اکسل.",
    defaultOn: false,
  },
  {
    key: "attendance",
    label: "حضور و غیاب",
    description: "شیفت، ورود و خروج، مرخصی، مأموریت، اضافه‌کاری و کارکرد ماهانه.",
    defaultOn: false,
  },
  {
    key: "ai",
    label: "دستیار هوش مصنوعی",
    description: "خلاصه‌ی پروژه، پیشنهاد تسک و جواب‌دادن از روی دانش سازمان.",
    defaultOn: false,
    comingSoon: true,
  },
];

/* Only the ones a workspace can actually turn on today. The «بزودی» entries are
 * listed so the picker says what is coming, but they are never storable — a
 * stored `true` for a module with no screens behind it would light up a sidebar
 * entry that goes nowhere the day it ships. */
export const SELECTABLE_MODULES = MODULES.filter((item) => !item.comingSoon);

export const MODULE_KEYS = SELECTABLE_MODULES.map((item) => item.key);

export const DEFAULT_MODULES = SELECTABLE_MODULES.filter(
  (item) => item.defaultOn,
).map((item) => item.key);

export const moduleLabel = (key) =>
  MODULES.find((item) => item.key === key)?.label ?? key;

export default MODULES;
